import { Flex, Th } from "@chakra-ui/react";

export function ThSort({ children }: { children: React.ReactNode }) {
  const SortIcon = () => {
    return (
      <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M7.13422 5.43019H1.53258C1.36461 5.43006 1.2003 5.37804 1.05964 5.28047C0.918989 5.1829 0.808057 5.04398 0.740351 4.88062C0.672645 4.71727 0.651084 4.53652 0.678294 4.36038C0.705503 4.18424 0.780309 4.0203 0.893606 3.88852L3.53713 1.03513C3.63999 0.917657 3.76475 0.824228 3.90345 0.760798C4.04216 0.697367 4.19177 0.665324 4.34277 0.666709C4.49377 0.668094 4.64284 0.702877 4.78049 0.768842C4.91815 0.834808 5.04137 0.930511 5.14231 1.04986L7.76301 3.87683C7.87932 4.00749 7.95707 4.17149 7.98665 4.34859C8.01624 4.52568 7.99636 4.7081 7.92948 4.87332C7.8626 5.03855 7.75164 5.17933 7.61031 5.2783C7.46898 5.37726 7.30347 5.43006 7.13422 5.43019ZM4.3334 12C4.18074 11.9999 4.02981 11.9657 3.89044 11.8995C3.75107 11.8333 3.62638 11.7367 3.52449 11.6159L0.903794 8.79063C0.787427 8.66002 0.709629 8.49604 0.680015 8.31895C0.650401 8.14186 0.670271 7.95944 0.737168 7.79422C0.804065 7.629 0.915057 7.48824 1.05642 7.38933C1.19779 7.29043 1.36333 7.23771 1.53258 7.23771H7.13422C7.30211 7.2378 7.46635 7.28976 7.60696 7.38725C7.74757 7.48474 7.85848 7.62357 7.92618 7.78684C7.99389 7.9501 8.01547 8.13076 7.98831 8.30682C7.96115 8.48289 7.88641 8.64676 7.77319 8.77851L5.12967 11.6319C5.02829 11.7487 4.90512 11.8417 4.76802 11.9051C4.63092 11.9684 4.48291 12.0008 4.3334 12Z"
          fill="#B6B3B9"
        />
      </svg>
    );
  };

  return (
    <Th cursor="pointer">
      <Flex alignItems="center" gap={2}>
        {children}
        <SortIcon />
      </Flex>
    </Th>
  );
}
